export default "__VITE_ASSET__RZTR6R7l__"